import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { getPages } from 'component/pagination/utils'
import { showSpinner, hideSpinner } from 'action/spinner'
import {
  FETCH_SECTIONS_ACCURACY_REQUEST,
  FETCH_SECTIONS_ACCURACY_SUCCESS,
  FETCH_SECTIONS_ACCURACY_ERROR,
  FETCH_EFFECTIVENESS_SUCCESS,
  FETCH_SECTIONS_ACC_EFFEC_REQUEST,
  FETCH_SECTIONS_ACC_EFFEC_SUCCESS,
  FETCH_SECTIONS_ACC_EFFEC_ERROR,
} from 'actionTypes'

/*
 * REQUEST SECTIONS_ACCURACYS
 */
export const fetchSectionsAccuracy =
  (token, filters, signalController) =>
  (dispatch) => {

    dispatch(fetchSectionsAccuracyRequest())

    const onClose = () => {

      dispatch(hideSpinner())
    }
  
    const onError = (error) => {
      dispatch(fetchSectionsAccuracyError(error))
      onClose()
    }

    const abort = () => {
      signalController.abort()
      dispatch(hideSpinner())
      dispatch(hideSpinner())
    }
  
  
    const onMessage = (response) => {
      dispatch(getPages(response.metadata))
      if(filters.isAccuracy) {
        dispatch(fetchSectionsAccuracySuccess(response.data))
      }
      else {
        dispatch(fetchEffectivenessSuccess(response.data))
      }
      dispatch(hideSpinner())
    }

    dispatch(showSpinner("", true, abort))

    return new Api(token, dispatch)
      .eventSourceStream(
       
        API_URL.SECTIONS_ACCURACY_FIND,
        filters,
        null,
        signalController,
        onMessage,
        onClose,
        onError
      )
      .catch((error) => {
        onError(error)
      })

    
  }

export const fetchSectionsAccEffec = (auth, params, signalController) => (dispatch) => {

    dispatch(fetchSectionsAccEffecRequest())
    const onClose = () => {
      dispatch(hideSpinner())
    }
  
    const onError = (error) => {
      dispatch(fetchSectionsAccEffecError(error))
      onClose()
    }
  
    const onMessage = (response) => {
      dispatch(fetchSectionsAccEffecSuccess(response.data))
    }

    const abort = () => {
      signalController.abort()
      dispatch(hideSpinner())
      dispatch(hideSpinner())
      onClose()
    }
  
    dispatch(showSpinner("", true, abort))
  
    return new Api(auth.user.dsToken, dispatch)
      .eventSourceStream(API_URL.SUPPLY_FETCH_ACC_EFFEC, params, null, signalController, onMessage, onClose, onError)
      .catch(error => onError(error))
  }

export const fetchSectionsAccuracyRequest = () => ({
  type: FETCH_SECTIONS_ACCURACY_REQUEST,
})

export const fetchSectionsAccuracySuccess = (data) => ({
  type: FETCH_SECTIONS_ACCURACY_SUCCESS,
  payload: data,
})

export const fetchEffectivenessSuccess = (data) => ({
  type: FETCH_EFFECTIVENESS_SUCCESS,
  payload: data,
})

export const fetchSectionsAccuracyError = (error) => ({
  type: FETCH_SECTIONS_ACCURACY_ERROR,
  payload: error,
})

export const fetchSectionsAccEffecRequest = () => ({
  type: FETCH_SECTIONS_ACC_EFFEC_REQUEST,
})

export const fetchSectionsAccEffecSuccess = (data) => ({
  type: FETCH_SECTIONS_ACC_EFFEC_SUCCESS,
  payload: data,
})

export const fetchSectionsAccEffecError = (error) => ({
  type: FETCH_SECTIONS_ACC_EFFEC_ERROR,
  payload: error,
})
